var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "email-not-synced" }, [
    _c("div", { staticClass: "email-not-synced__content-wrapper" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "email-not-synced__content" }, [
        _c("h3", { staticClass: "email-not-synced__title" }, [
          _vm._v(
            "\n                " +
              _vm._s(
                _vm.$l10n.__("Envoyez et recevez vos emails dans Sellsy")
              ) +
              "\n            "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "email-not-synced__subtitle" }, [
          _vm._v(
            "\n                " +
              _vm._s(
                _vm.$l10n.__(
                  "Centralisez vos emails pour un suivi idéal et afin de profiter pleinement des fonctionnalités associées comme la consultation des coordonnées d’un contact, l’envoi programmé d’email, la création de tâches ou d’événements liés et bien plus encore !"
                )
              ) +
              "\n            "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _vm.isAdmin || !_vm.isEmailsSentFromCorp
          ? _c(
              "router-link",
              { attrs: { to: { name: "onboarding.email" } } },
              [
                _c("CompassButton", {
                  attrs: { label: _vm.$t.__("email.configure_email_service") }
                })
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          src: "/ressources/logged/img/illustrations/no-email-connected.svg"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }